import { useState, useEffect } from 'react'
import { useCV } from './useCV'
import { KERNELS } from './convolution'

// HTML overlay for the interactive convolution scene (scene index 4).
// `mobileInline` renders it in normal document flow (for the mobile
// continuous-scroll layout) instead of as a fixed overlay gated on the
// GSAP-driven `scene` index, which the mobile layout never sets.
export function CVControls({ mobileInline = false }) {
  const scene = useCV(s => s.scene)
  const kernelId = useCV(s => s.kernelId)
  const setKernelId = useCV(s => s.setKernelId)
  const useWebcam = useCV(s => s.useWebcam)
  const setUseWebcam = useCV(s => s.setUseWebcam)
  const [mobile, setMobile] = useState(() => window.innerWidth < 768)
  useEffect(() => {
    const handler = () => setMobile(window.innerWidth < 768)
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [])

  if (!mobileInline && scene !== 4) return null

  return (
    <div style={mobileInline ? {
      position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10,
      pointerEvents: 'auto', width: '100%',
    } : {
      position: 'fixed', bottom: mobile ? 120 : 92, left: '50%', transform: 'translateX(-50%)',
      zIndex: 60, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10,
      pointerEvents: 'auto', width: mobile ? '90vw' : undefined,
    }}>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', justifyContent: 'center', maxWidth: 520 }}>
        {KERNELS.map(k => {
          const active = k.id === kernelId
          return (
            <button
              key={k.id}
              onClick={() => setKernelId(k.id)}
              style={{
                padding: '6px 12px', borderRadius: 8, cursor: 'pointer',
                fontFamily: 'monospace', fontSize: 11, letterSpacing: '0.04em',
                color: active ? '#fff' : 'rgba(255,255,255,0.55)',
                background: active ? 'rgba(168,85,247,0.28)' : 'rgba(255,255,255,0.05)',
                border: `1px solid ${active ? '#a855f7' : 'rgba(255,255,255,0.12)'}`,
                boxShadow: active ? '0 0 14px rgba(168,85,247,0.45)' : 'none',
                transition: 'all 0.2s', backdropFilter: 'blur(8px)',
              }}
            >
              {k.label}
            </button>
          )
        })}
      </div>

      <button
        onClick={() => setUseWebcam(!useWebcam)}
        style={{
          padding: '7px 16px', borderRadius: 20, cursor: 'pointer',
          fontFamily: 'monospace', fontSize: 11, letterSpacing: '0.06em',
          color: useWebcam ? '#fff' : 'rgba(255,255,255,0.6)',
          background: useWebcam ? 'rgba(34,197,94,0.25)' : 'rgba(255,255,255,0.05)',
          border: `1px solid ${useWebcam ? '#22c55e' : 'rgba(255,255,255,0.15)'}`,
          boxShadow: useWebcam ? '0 0 14px rgba(34,197,94,0.4)' : 'none',
          transition: 'all 0.2s', backdropFilter: 'blur(8px)',
        }}
      >
        {useWebcam ? '● LIVE CAMERA — click to use sample image' : '○ Use my camera'}
      </button>
    </div>
  )
}
